module.exports = __webpack_public_path__ + "img/company-manage-o.ca2b654e.svg";